import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { RouteGuard } from '@core/components/navigation/RouteGuard';
import DashboardLayout from '@core/layouts/DashboardLayout';
import { ROUTES } from '@core/utils/constants';

const Dashboard = lazy(() => import('@dashboard/index'));

const DashboardRouter = {
  element: (
    <RouteGuard mode="protected">
      <DashboardLayout />
    </RouteGuard>
  ),
  children: [
    { path: ROUTES.app.root, element: <Navigate to={ROUTES.app.dashboard} /> },
    { path: ROUTES.app.dashboard, element: <Dashboard /> },
  ],
};

export default DashboardRouter;
